import { useNavigate } from "react-router-dom";

const TabButtonGroup = ({
  buttonLabels = [],
  selectedIndex,
  setSelectedIndex,
  gapClass = "gap-x-1 md:gap-x-4", // default gap
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`w-full max-w-full md:w-[758px] scrollbar-hide rounded-[16px] flex items-center justify-start pr-0 md:pr-2 overflow-x-auto ${gapClass}`}
    >
      {buttonLabels.map((item, i) => (
        <button
          key={i}
          onClick={() => {
            setSelectedIndex(i);
            navigate(item.path);
          }}
          className={`md:min-w-[100px] min-w-[70px] h-[26px] flex items-center justify-center rounded-[16px] px-2 pb-[2px] border-b-2 ${
            (selectedIndex ?? 0) === i ? "border-black" : "border-transparent"
          }`}
        >
          <span className="text-[12px] font-normal leading-[100%] font-inter text-black whitespace-nowrap">
            {item.label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default TabButtonGroup;
